import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { CatalogForm } from '../../../components/CatalogForm/CatalogForm';
import { Validators } from '../../../components/CatalogForm/validators';
import { EmbalajeService } from '../../../services/EmbalajeService';

const EmbalajeForm = () => {
  const routeParams = useParams() || {};
  const id = routeParams.id || null;

  // Options states
  const [gruposOptions, setGruposOptions] = useState([]);

  // Load grupos options
  useEffect(() => {
    let isMounted = true;
    const fetchOptions = async () => {
      const grupos = await EmbalajeService.obtenerGruposEmbalaje();
      if (isMounted && Array.isArray(grupos)) {
        setGruposOptions(grupos);
      }
    };
    fetchOptions();
    return () => {
      isMounted = false;
    };
  }, []);

  // Pre-load data in edit mode
  const loadData = useCallback(async (recordId) => {
    return await EmbalajeService.obtenerPorId(recordId);
  }, []);

  // Submit handler
  const handleSubmit = useCallback(async (values) => {
    const payload = {
      ...values,
      id: id,
      id_embalaje_grupo: values.id_embalaje_grupo ? Number(values.id_embalaje_grupo) : values.id_embalaje_grupo,
    };
    return await EmbalajeService.guardar(payload);
  }, [id]);

  // Form field configurations
  const fields = useMemo(() => [
    {
      name: 'embalaje',
      label: 'Clave',
      type: 'text',
      col: 4,
      required: true,
      placeholder: 'Ej. CJ, PAL, etc.',
      validators: [Validators.required('La clave de embalaje es obligatoria')],
    },
    {
      name: 'embalaje_nombre',
      label: 'Descripción',
      type: 'text',
      col: 4,
      required: true,
      placeholder: 'Ej. Caja de cartón',
      validators: [
        Validators.required('La descripción del embalaje es obligatoria'),
        Validators.maxLength(250, 'La descripción no puede exceder 250 caracteres'),
      ],
    },
    {
      name: 'id_embalaje_grupo',
      label: 'Grupo de Embalaje',
      type: 'select',
      col: 4,
      required: true,
      options: gruposOptions,
      placeholder: 'Seleccionar grupo...',
      validators: [Validators.required('El grupo de embalaje es obligatorio')],
    },
  ], [gruposOptions]);

  return (
    <CatalogForm
      title="Embalaje"
      subtitle="Administración de tipos de embalajes y clasificación"
      fields={fields}
      initialValues={{
        embalaje: '',
        embalaje_nombre: '',
        id_embalaje_grupo: '',
      }}
      id={id}
      loadData={loadData}
      onSubmit={handleSubmit}
      backUrl="/Catalogo/Embalajes"
    />
  );
};

export default EmbalajeForm;
